import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth, db } from '../../firebase';
import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';


const Registro = () => {
const [form, setForm] = useState({
  nombres: '',
  apellidos: '',
  rut: '',
  correo: '',
  celular: '+569',
  t_emergencia: '',
  password: '',
  confirmPassword: ''
});


  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const [showCreds, setShowCreds] = useState(false);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // 🔴 Validación de campos obligatorios (los marcados con *)
    if (
      !form.nombres ||
      !form.apellidos ||
      !form.rut ||
      !form.correo ||
      !form.celular
    ) {
      setError('Por favor completa los campos obligatorios marcados con *.');
      return;
    }

    if (form.password !== form.confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    try {
      const emailKey = form.correo.toLowerCase().trim();

      const cred = await createUserWithEmailAndPassword(auth, emailKey, form.password);
      const user = cred.user;

      // 🔍 Verificar si ya existe paciente creado manualmente con este correo
      const refExistente = doc(db, "usuarios", emailKey);
      const snapExistente = await getDoc(refExistente);

      let esPacienteManual = false;
      if (snapExistente.exists()) {
        esPacienteManual = true;

        await setDoc(
          refExistente,
          {
            uid: user.uid,
            correo: emailKey,

            nombres: form.nombres.trim(),
            apellidos: form.apellidos.trim(),
            rut: form.rut.trim(),
            celular: form.celular.trim(),
            t_emergencia: (form.t_emergencia || "").trim(),

            origen: "manual+registro",
            actualizadoEn: serverTimestamp(),
          },
          { merge: true }
        );
      }

      await setDoc(doc(db, 'roles', user.uid), {
        admin: false,
        worker: false,
        user: true,
        creadoEn: serverTimestamp()
      });

    if (!esPacienteManual) {
    await setDoc(doc(db, "usuarios", emailKey), {
      uid: user.uid,
      correo: emailKey,

      nombres: form.nombres.trim(),
      apellidos: form.apellidos.trim(),
      rut: form.rut.trim(),
      celular: form.celular.trim(),
      t_emergencia: (form.t_emergencia || "").trim(),

      origen: "registro",
      creadoEn: serverTimestamp(),
    });
    }

      setSuccess('✅ Cuenta creada correctamente');
      navigate('/agenda');

    } catch (err) {
      console.error('❌ Error al registrar:', err.code, err.message);
      setError('Error al crear la cuenta: ' + err.message);
    }
  };

  const handleGoogleRegister = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const emailKey = user.email.toLowerCase().trim();

      await setDoc(doc(db, 'roles', user.uid), {
        admin: false,
        worker: false,
        user: true,
        creadoEn: serverTimestamp()
      }, { merge: true });

      const ref = doc(db, 'usuarios', emailKey);
      const snap = await getDoc(ref);

      if (!snap.exists()) {
      await setDoc(ref, {
        uid: user.uid,
        correo: emailKey,

        nombres: user.displayName || "",
        apellidos: "",
        rut: "",
        celular: "",
        t_emergencia: "",

        origen: "google",
        creadoEn: serverTimestamp(),
      });
      }

      navigate('/agenda');

    } catch (err) {
      console.error('❌ Error con Google:', err);
      setError('No se pudo registrar con Google.');
    }
  };

return (
  <div
    className="min-h-screen flex justify-center items-start px-4 py-10"
    style={{
      background: "linear-gradient(to bottom right, #EAF6FF, #DCEFFF, #F8FAFC)",
    }}
  >
    <div
      className="max-w-4xl w-full h-auto bg-white/60 backdrop-blur-xl rounded-3xl
                 shadow-[0_18px_50px_-15px_rgba(58,106,255,0.35)] ring-1 ring-blue-100 p-10"
    >
      <h1 className="text-3xl md:text-4xl font-extrabold text-blue-900 text-center mb-3">
        Crear Cuenta
      </h1>

      <p className="text-center text-sm text-gray-600 mb-7">
        Para reservar debes registrarte o iniciar sesión
      </p>

      {/* ✅ GOOGLE PRIMERO */}
        <button
          onClick={async () => {
            setShowCreds(false);
            await handleGoogleRegister();
          }}
          className="
            w-full py-3 rounded-xl
            bg-white border border-[#dadce0]
            text-[#3c4043] font-semibold
            hover:bg-[#f8f9fa]
            transition
            flex items-center justify-center gap-3
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            className="w-5 h-5"
            aria-hidden="true"
          >
            <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303C33.651 32.657 29.233 36 24 36c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.277 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
            <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 16.108 18.961 13 24 13c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.277 4 24 4c-7.682 0-14.347 4.337-17.694 10.691z"/>
            <path fill="#4CAF50" d="M24 44c5.176 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.18 35.091 26.715 36 24 36c-5.212 0-9.617-3.329-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
            <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.793 2.237-2.231 4.166-4.084 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
          </svg>

          <span>Registrarse con Google</span>
        </button>

      {/* Divider */}
      <div className="flex items-center my-6">
        <hr className="flex-grow border-gray-300" />
        <span className="mx-4 text-gray-500 text-sm">o</span>
        <hr className="flex-grow border-gray-300" />
      </div>

      {/* ✅ BOTÓN DESPLEGABLE */}
      <button
        type="button"
        onClick={() => setShowCreds((v) => !v)}
        className="w-full bg-[#3A6AFF] hover:bg-blue-700 text-white py-3 rounded-xl font-semibold transition"
      >
        {showCreds
          ? "Ocultar registro con correo y contraseña"
          : "Registrarse con correo y contraseña"}
      </button>

      {/* ✅ PANEL DESPLEGABLE: TU FORM COMPLETO */}
      <div
        className={`
          overflow-hidden transition-all duration-300
          ${showCreds ? "max-h-[5000px] opacity-100 mt-6" : "max-h-0 opacity-0 mt-0"}
        `}
      >
        <form onSubmit={handleRegister} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* NOMBRES (OBLIGATORIO) */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Nombres <span className="text-red-500">*</span>
              </label>
              <input
                name="nombres"
                placeholder="Ej: Juan Carlos"
                className="w-full border border-blue-100 rounded-xl px-4 py-3 bg-white/90
                           focus:outline-none focus:ring-2 focus:ring-[#3A6AFF]"
                onChange={handleChange}
                required={showCreds}
              />
            </div>

            {/* APELLIDOS (OBLIGATORIO) */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Apellidos <span className="text-red-500">*</span>
              </label>
              <input
                name="apellidos"
                placeholder="Ej: Pérez Soto"
                className="w-full border border-blue-100 rounded-xl px-4 py-3 bg-white/90
                           focus:outline-none focus:ring-2 focus:ring-[#3A6AFF]"
                onChange={handleChange}
                required={showCreds}
              />
            </div>

            {/* RUT (OBLIGATORIO) */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                RUT <span className="text-red-500">*</span>
              </label>
              <input
                name="rut"
                placeholder="Ej: 12.345.678-9"
                className="w-full border border-blue-100 rounded-xl px-4 py-3 bg-white/90
                           focus:outline-none focus:ring-2 focus:ring-[#3A6AFF]"
                onChange={handleChange}
                required={showCreds}
              />
            </div>

            {/* CORREO (OBLIGATORIO) */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Correo electrónico <span className="text-red-500">*</span>
              </label>
              <input
                name="correo"
                type="email"
                placeholder="correo@ejemplo.com"
                className="w-full border border-blue-100 rounded-xl px-4 py-3 bg-white/90
                           focus:outline-none focus:ring-2 focus:ring-[#3A6AFF]"
                onChange={handleChange}
                required={showCreds}
              />
            </div>

            {/* CELULAR (OBLIGATORIO) */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Número de celular <span className="text-red-500">*</span>
              </label>
              <input
                name="celular"
                value={form.celular}
                onChange={(e) => {
                  let v = e.target.value;
                  if (!v.startsWith("+569")) {
                    const numeros = v.replace(/[^0-9]/g, "");
                    if (numeros.startsWith("569")) v = "+569" + numeros.slice(3);
                    else v = "+569" + numeros;
                  }
                  setForm((prev) => ({ ...prev, celular: v }));
                }}
                onKeyDown={(e) => {
                  const cursor = e.target.selectionStart;
                  if (cursor <= 4 && (e.key === "Backspace" || e.key === "Delete")) {
                    e.preventDefault();
                  }
                }}
                onClick={(e) => {
                  if (e.target.selectionStart < 4) {
                    e.target.setSelectionRange(4, 4);
                  }
                }}
                className="w-full border border-blue-100 rounded-xl px-4 py-3 bg-white/90
                           focus:outline-none focus:ring-2 focus:ring-[#3A6AFF]"
                required={showCreds}
              />
            </div>

            {/* TELÉFONO EMERGENCIA (OPCIONAL) */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Teléfono de emergencia
              </label>
              <input
                name="t_emergencia"
                placeholder="+56 9 9876 5432"
                className="w-full border border-blue-100 rounded-xl px-4 py-3 bg-white/90
                           focus:outline-none focus:ring-2 focus:ring-[#3A6AFF]"
                onChange={handleChange}
              />
            </div>

            {/* PASSWORD (OBLIGATORIO) */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Contraseña <span className="text-red-500">*</span>
              </label>
              <input
                name="password"
                type="password"
                placeholder="Mínimo 6 caracteres"
                className="w-full border border-blue-100 rounded-xl px-4 py-3 bg-white/90
                           focus:outline-none focus:ring-2 focus:ring-[#3A6AFF]"
                onChange={handleChange}
                required={showCreds}
              />
            </div>

            {/* CONFIRM PASSWORD (OBLIGATORIO) */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Repetir contraseña <span className="text-red-500">*</span>
              </label>
              <input
                name="confirmPassword"
                type="password"
                placeholder="Repite la contraseña"
                className="w-full border border-blue-100 rounded-xl px-4 py-3 bg-white/90
                           focus:outline-none focus:ring-2 focus:ring-[#3A6AFF]"
                onChange={handleChange}
                required={showCreds}
              />
            </div>
          </div>

          {error && <p className="text-red-500 text-sm">{error}</p>}
          {success && <p className="text-green-600 text-sm">{success}</p>}

          <button
            type="submit"
            className="w-full bg-[#0A1440] hover:opacity-90 text-white py-3 rounded-xl font-semibold transition"
          >
            Crear cuenta
          </button>
        </form>
      </div>

      {/* footer: ya tienes cuenta */}
      <p className="text-center text-sm mt-8">
        ¿Ya tienes una cuenta?{" "}
        <button
          onClick={() => navigate("/login")}
          className="text-blue-600 hover:underline"
        >
          Inicia sesión
        </button>
      </p>
    </div>
  </div>
);

};

export default Registro;
